/**
 * 多 Tab 页面 Token 同步模块
 *
 * 解决无糖浏览器环境下，多个 tab 页面因 token 不同步导致的登录过期问题
 * 当一个 tab 换票登录后，其他旧 tab 会自动同步最新的 token
 */

const TOKEN_KEYS = ['t_k', 'token', 'time', 'roles'];
const TAG = '[Token同步]';

let isListening = false;

/**
 * 初始化 Token 同步监听器
 * 当其他 tab 更新 localStorage 的 token 时，当前 tab 自动同步
 */
export function initTokenSync() {
  if (typeof window === 'undefined' || !window.localStorage) {
    return;
  }

  if (isListening) {
    console.log(TAG, '已经初始化过，跳过重复初始化');
    return;
  }

  window.addEventListener('storage', handleStorageChange);
  isListening = true;
  console.log(TAG, '✅ Token 同步监听器已启动');
}

/**
 * 销毁 Token 同步监听器
 */
export function destroyTokenSync() {
  if (typeof window === 'undefined') {
    return;
  }

  window.removeEventListener('storage', handleStorageChange);
  isListening = false;
  console.log(TAG, '❌ Token 同步监听器已销毁');
}

/**
 * 处理 storage 事件
 * @param {StorageEvent} event
 */
function handleStorageChange(event) {
  // storage 事件只在其他 tab 修改 localStorage 时触发，当前 tab 不会触发
  if (!event || event.storageArea !== window.localStorage) {
    return;
  }

  const { key, newValue, oldValue } = event;

  // 只关注 token 相关的 key
  if (!TOKEN_KEYS.includes(key)) {
    return;
  }

  // 如果是 token 被删除（退出登录），不处理，让 401 响应拦截器处理
  if (!newValue && oldValue) {
    console.log(TAG, `检测到其他 Tab 删除了 ${key}，可能是退出登录`);
    return;
  }

  // 如果是 token 被更新
  if (newValue && newValue !== oldValue) {
    console.log(TAG, `检测到其他 Tab 更新了 ${key}`);
    console.log(TAG, `  旧值: ${oldValue?.substring(0, 20)}...`);
    console.log(TAG, `  新值: ${newValue?.substring(0, 20)}...`);
    console.log(TAG, '  ✅ 当前 Tab 已自动同步最新值');

    // localStorage 已经被其他 tab 更新了，这里不需要再次写入
    // 只需要通知应用层 token 已更新（如果需要的话）
    notifyTokenUpdated(key, newValue);
  }
}

/**
 * 通知应用层 token 已更新
 * 可以在这里触发自定义事件，让 Vue 组件响应
 * @param {string} key
 * @param {string} newValue
 */
function notifyTokenUpdated(key, newValue) {
  // 触发自定义事件，供 Vue 组件监听（可选）
  if (typeof window !== 'undefined' && window.CustomEvent) {
    const event = new CustomEvent('tokenSynced', {
      detail: { key, newValue }
    });
    window.dispatchEvent(event);
  }
}
